module.exports = __webpack_public_path__ + "media/headline.d6071fc1.aac";